import { useEffect } from 'react';
import { parseThemeColors, applyThemeToDOM } from './theme';
export { parseThemeColors } from './theme';
export function useTheme(themeColorsRaw: unknown) {
  useEffect(() => { applyThemeToDOM(parseThemeColors(themeColorsRaw)); }, [themeColorsRaw]);
}
